import DatePicker from 'react-date-picker';
import PropTypes from 'prop-types';
import './Datepicker.scss';
import Images from 'assets/Images';

export default function DatePickers(props) {
	const { onChange, value, last, label, infoContent, minDate, isDisabled, mandatory, maxDate, centerAlign } = props;

	return (
		<>
			<div className={`datepicker-row ${last ? 'datepicker-row--last' : isDisabled ? 'datepicker-row--disabled' : ''} ${centerAlign && 'datepicker-row--center'}`}>
				{label && (
					<label>
						{label} {mandatory && <sup>*</sup>}
						{infoContent && (
							<div className='datepicker-row__helpContainer'>
								<div className='datepicker-row__help'>
									<img src={Images.help} />
								</div>
								<div className='datepicker-row__helpContent'>{infoContent}</div>
							</div>
						)}
					</label>
				)}
				<div className='datepicker-row__block' onClick={() => !isDisabled && onChange(null)}>
					<DatePicker onChange={onChange} value={value} minDate={minDate} maxDate={maxDate} onFocus={e => e.target.blur()} format='dd-MM-y' disabled={isDisabled} dayPlaceholder='DD' monthPlaceholder='MM' yearPlaceholder='YYYY' />
				</div>
			</div>
		</>
	);
}

DatePickers.propTypes = {
	centerAlign: PropTypes.bool,
	mandatory: PropTypes.bool,
	last: PropTypes.bool,
	isDisabled: PropTypes.bool,
	value: PropTypes.any,
	label: PropTypes.string,
	minDate: PropTypes.any,
	maxDate: PropTypes.any
};

DatePickers.defaultProps = {
	last: false,
	isDisabled: false,
	centerAlign: false,
	mandatory: false,
	label: ''
};
